<template>
    <div id="caseLink">
        <ul>
            <li @click="returnTop('#caseList')">典型案例</li>
            <li @click="returnTop('#caseSearch')">全部案例</li>
            <li @click="returnTop('#customerContainer')">重要客户及合作单位</li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'Screen2',
    methods:{
        returnTop:function(dis){
            document.querySelector(dis).scrollIntoView({behavior:'smooth',block:'center'});
        }
    }
}
</script>

<style scoped>
    #caseLink{
        background: #edf0f5;
        line-height: 45px;
    }
    #caseLink>ul{
        width:1120px;
        margin: 0 auto;
        overflow: hidden;
    }
    #caseLink>ul>li{
        float: left;
        text-align: center;
        width: 33.333333%;
        cursor: pointer;
        font-size: 16px;
    }
</style>
